// FETCH
export const MAYBE_FETCH_REQUEST = 'MAYBE_FETCH_REQUEST';
export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';

export const CLEAR_SURVEY_RESPONSES = 'CLEAR_SURVEY_RESPONSES';
export const UPDATE_RESPONSE_STATE = 'UPDATE_RESPONSE_STATE';
export const UPDATE_TIMING_STATE = 'UPDATE_TIMING_STATE';

export const UPDATE_SELECTED_QUESTIONS = 'UPDATE_SELECTED_QUESTIONS';
